import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


const CreateTaskPopup = ({ modal, toggle, save }) => {
    const [taskName, setTaskName] = useState('');
    const [description, setDescription] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target
        if (e.target.scrollHeight === e.target.clientHeight) {
            if (name === "taskName") {
                setTaskName(value)
                //  console.log(value)
            } else {
                setDescription(value)
                //  console.log(value)
            }
        }
    }

    const handleSave = (e) => {
        e.preventDefault()
        let taskObj = {}
        taskObj["t_할일제목"] = taskName
        taskObj["t_할일내용"] = description
        save(taskObj)
    }


    return (
            <Modal size='sm' isOpen={modal} toggle={toggle} >
                <ModalHeader toggle={toggle}>일정등록</ModalHeader>
                <ModalBody>
                    <div className="form-group">
                        <label style={{ color: 'blue', fontWeight: 'bolder' }}>제목</label>
                        <input type="text" className="form-control" value={taskName} onChange={handleChange} name="taskName" />
                    </div>
                    <div className="form-group">
                        <label style={{ color: 'blue', fontWeight: 'bolder'}}>내용</label>
                        <textarea wrap='hard' cols={30} rows={5} className = "form-control" value = {description} onChange = {handleChange} name = "description"></textarea>
                    </div>

                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleSave}>저장</Button>{' '}
                    <Button color="secondary" onClick={toggle}>취소</Button>
                </ModalFooter>
            </Modal>
    );
};

export default CreateTaskPopup;